import { Component, EventEmitter, OnInit, OnDestroy, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';


interface VariationOption {
  key: string;
  label: string;
}

@Component({
  selector: 'app-dashboard-filters',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './dashboard-filters.html',
  styleUrls: ['./dashboard-filters.scss']
})
export class DashboardFilters implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private http = inject(HttpClient);

  variationOptions: VariationOption[] = [];
  alcances = ['Todas','1','2','3'];
  categorias = ['Todas','1','2','3','4','5','6'];
  pcg = ['AR4', 'AR5', 'AR6'];
  year = ['2021', '2022', '2023', '2024', '2025', '2026'];

  filtro = {
    empresa: 'Todas',
    sede: 'Todas',
    variations: 'Todas',
    alcance: 'Todas',
    pcg: 'AR6',
    year: '2026',
    mode: 'alcance'
  };

  @Output() apply = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    this.loadVariations();
  }

  private loadVariations(): void {
    this.http.get<any>('assets/data/sources.json')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          const variationsData = data?.variations || {};
          this.variationOptions = [
            { key: 'Todas', label: 'Todas' },
            ...Object.entries(variationsData).map(([key, label]) => ({
              key,
              label: label as string
            }))
          ];
        },
        error: (error) => {
          console.error('Error loading variations from sources.json:', error);
          // Fallback to empty list if loading fails
          this.variationOptions = [{ key: 'Todas', label: 'Todas' }];
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onApply() {
    this.apply.emit(this.filtro);
  }

  onClear() {
    this.filtro = {
      empresa: 'Todas',
      sede: 'Todas',
      variations: 'Todas',
      alcance: 'Todas',
      pcg: 'AR6',
      year: '2026',
      mode: 'alcance'
    };
    this.apply.emit(this.filtro);
  }

  setMode(mode: 'alcance' | 'categoria') {
    this.filtro.mode = mode;
  }
}